import styled from 'styled-components';
import Image from '../../Common/Image/Image';

export const Icon = styled(Image)`
	height: auto;
	max-height: 100%;
	max-width: 100%;
	width: auto;
`;

export const NoResultsContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
`;
